import type { AsyncThunkApiConfig } from '@/store'

import { createAsyncThunk } from '@reduxjs/toolkit'
import { RejectError } from '../../typings'

type Params = uui.domain.actions.rpc.simulation.DuplicateSimulationAction['params']

/**
 * Duplicate a simulation.
 *
 * @private
 */
export const duplicateSimulation = createAsyncThunk<
  // Return type of the payload creator
  string,
  // First argument to the payload creator
  Params,
  // thunk API
  AsyncThunkApiConfig<RejectError>
>('domain/simulation/duplicate', async (params, thunkApi) => {
  try {
    const rpc = thunkApi.extra.domainProxy.getRpc()

    const result = await rpc('rpc/simulation/duplicate', {
      category: 'rpc',
      type: 'rpc/simulation/duplicate',
      params,
    })

    if (result.type === 'rpc-failure') {
      return thunkApi.rejectWithValue({
        type: 'rpcFailure',
        message: result.errorMessage,
        error: result,
      })
    }

    return result.createdSimulationId
  } catch (error) {
    thunkApi.extra.journal.main(
      'Unknown error on {duplicateSimulation}',
      { tags: ['rpc', 'simulation'] },
      'error',
    )

    return thunkApi.rejectWithValue({
      type: 'unknown',
      message: 'Duplicate Simulation Failed',
      error,
    })
  }
})
